import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import * as Actions from "../../../store/actions"
import { useSelector, useDispatch } from "react-redux"
import { DefaultModality } from 'amazon-chime-sdk-js';
import moment from "moment"
import { isChrome, isFirefox, isSafari, isMobileSafari } from "react-device-detect";
import Linkify from 'react-linkify';
import Swal from "sweetalert2"
import { VERSION_NO } from '../../../store/actions';

const PeoplesAndChat = props => {

    const dispatch = useDispatch()

    const [People, setPeople] = useState({})
    const [useLess, setuseLess] = useState(1)
    const [Message, setMessage] = useState("")
    const [Messages, setMessages] = useState([])
    const [Loading, setLoading] = useState(false)

    const meetingSession = useSelector(({ meeting }) => meeting.meetingSession)
    const VideoTilesPeople = useSelector(({ meeting }) => meeting.VideoTilesPeople)
    const Chat = useSelector(({ meeting }) => meeting.Chat)
    const baseURL = useSelector(({ utils }) => utils.baseURL);
    const People2 = useSelector(({ meeting }) => meeting.People)
    const ScreenShareOn = useSelector(({ meeting }) => meeting.ScreenShareOn);
    const isAuth = useSelector(({ auth }) => auth.isAuth)
    const UserData = useSelector(({ auth }) => auth.UserData);


    useEffect(() => {
        if (Chat.length > 0) {
            let elem = document.querySelector('.ChatMsg');
            if (elem) {
                elem.scrollTop = elem?.scrollHeight;
            }
        }
    }, [Chat])

    const DATA_MESSAGE_TOPIC = "CHAT"
    useEffect(() => {
        if (People2) setPeople(People2)

        UseLessFunction()
    }, [People2])


    function addMsg(dataMessage) {
    }
    function UseLessFunction() {
        setuseLess(useLess + 1)

        setTimeout(() => {
            UseLessFunction()
        }, 2000);
    }
    return (
        <div className="PeopleAndChat">
            {
                props.ChatTabType != "Chat" ? (
                    <>
                        <div className="People">
                            {/* <div className="AttendeeHeadingContiner">
                                <h5 style={{ color: "grey", margin: "0px" }}>
                                    Participants ({Object.keys(People).length})
                                </h5>
                            </div> */}

                            <div className="wrapperForParticipants">
                                {
                                    Object.keys(People)?.map((value, index) => {
                                        // ["", "","", "","", "","", "","", "","", "","", "","", "","", "","", "","", "","", "",].map((value, index) => {
                                        return (
                                            <div key={index} className="AttendeeContiner">
                                                <div className="d-flex align-items-center">
                                                    <img src={`https://ui-avatars.com/api/?name=${People[value]?.name}`}
                                                        style={{ width: "35px", height: "35px", borderRadius: "100%" }} />
                                                    <h5 className="Person" >
                                                        {People[value]?.name} {People[value]?.attendeeId == meetingSession?._configuration?.credentials?.attendeeId ? "(me)" : null}
                                                    </h5>
                                                </div>
                                                <span>
                                                    <img style={{ marginRight: "10px" }} src={People[value]?.muted ? "/images/mic-off.svg" : "/images/icons/Union_3.svg"} />
                                                    <img
                                                        style={{ marginRight: "10px" }}
                                                        src={VideoTilesPeople.includes(People[value]?.attendeeId) ? "/images/icons/video-camera.svg" : "/images/video-off.svg"}
                                                    />

                                                    {/* <img
                                        style={{ marginRight: "10px" }}
                                        src={"/images/video-off.svg"}
                                    /> */}
                                                </span>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>

                    </>
                ) : (
                    <>
                        <div className="Chat">
                            {/* <div className="AttendeeHeadingContiner">
                                <h5 style={{ color: "grey", margin: "0px" }}>
                                    Chat
                                </h5>

                            </div> */}

                            <div className="ChatMsg" style={{ overflowX: "hidden" }}>

                                {
                                    Chat.map((value, index) => {

                                        if (value.file) {
                                            // console.log(value.file, "file")
                                            let myCheck = value.file.split(".")[value.file.split(".").length - 1];
                                            // console.log(myCheck)
                                            if (myCheck == "pdf") {
                                                //dist\images\pdficon.png
                                                return (
                                                    <span
                                                        key={index}
                                                        onClick={() => {
                                                            window.open(baseURL + `/PT2/httpdocs/${VERSION_NO}/downloadVvChatFileV1?s3Key=${value.file}`, "_blank")
                                                        }}
                                                        style={{ padding: isSafari ? "40px" : "10px" }}
                                                        className={`ChatMsgBoxFile ${value.me ? " MyBox" : ""}`}>
                                                        <div className="Msg fileMsg" style={{ height: "115px" }}>
                                                            <img
                                                                style={{ maxWidth: "100%", maxHeight: "100px" }}
                                                                // className="img-fluid"
                                                                src={"/images/pdficon.png"}
                                                            />
                                                        </div>
                                                        <span className="info"> <span className="name">{value.name}</span> <span className="time">{moment(value.time).format("h:mm a")}</span> </span>
                                                    </span>
                                                )
                                            }
                                            if (myCheck == "png" || myCheck == "jpg" || myCheck == "jpeg" || myCheck == "webp") {
                                                return (

                                                    <span
                                                        key={index}
                                                        onClick={() => {
                                                            // window.open(baseURL + `/PT2/httpdocs/${VERSION_NO}/downloadVvChatFileV1?s3Key=${value.file}`, "_blank")
                                                            Swal.fire({
                                                                imageUrl: `${baseURL}/PT2/httpdocs/${VERSION_NO}/downloadVvChatFileV1?s3Key=${value.file}`,
                                                                imageWidth: 450,
                                                                imageAlt: value.file,
                                                                showCloseButton: true,
                                                                title: value.file,
                                                                allowEscapeKey: true,
                                                                allowOutsideClick: true,
                                                            })
                                                        }}
                                                        style={{ padding: isSafari ? "40px" : "10px" }}
                                                        className={`ChatMsgBoxFile ${value.me ? " MyBox" : ""}`}>
                                                        <div className="Msg fileMsg">
                                                            <img
                                                                style={{ maxWidth: "100%", maxHeight: "180px" }}
                                                                // className="img-fluid"
                                                                src={baseURL + `/PT2/httpdocs/${VERSION_NO}/downloadVvChatFileV1?s3Key=${value.file}`}
                                                            />
                                                        </div>
                                                        <span className="info"> <span className="name">{value.name}</span> <span className="time">{moment(value.time).format("h:mm a")}</span> </span>
                                                    </span>
                                                )
                                            } else {
                                                return (
                                                    <span
                                                        key={index}
                                                        onClick={() => {
                                                            window.open(baseURL + `/PT2/httpdocs/${VERSION_NO}/downloadVvChatFileV1?s3Key=${value.file}`, "_blank")
                                                        }}
                                                        style={{ padding: isSafari ? "40px" : "10px" }}
                                                        className={`ChatMsgBox ${value.me ? " MyBox" : ""}`}>
                                                        <div className="Msg fileMsg">{value.Text} </div>
                                                        <span className="info"> <span className="name">{value.name}</span> <span className="time">{moment(value.time).format("h:mm a")}</span> </span>
                                                    </span>
                                                )
                                            }

                                        }
                                        return (
                                            <div key={index} style={{ margin: isSafari ? "40px 0px" : "0px", }} className={`ChatMsgBox ${value.me ? " MyBox" : ""}`}>
                                                <div className="Msg">
                                                    <Linkify
                                                        componentDecorator={(decoratedHref, decoratedText, key) => (
                                                            <a style={{ color: value.me ? "#333333" : "white", textDecoration: "underline" }} target="blank" href={decoratedHref} key={key}>
                                                                {decoratedText}
                                                            </a>
                                                        )}

                                                    >
                                                        {value.Text}
                                                    </Linkify>
                                                </div>
                                                <span className="info"> <span className="name">{value.name}</span> <span className="time">{moment(value.time).format("h:mm a")}</span> </span>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className="Type">
                                <label htmlFor="filesss" style={{ cursor: "pointer" }} className="type1">
                                    <img
                                        style={{ height: "23px" }}
                                        // src="/images/icons/attachbtn.png"
                                        src={Loading ? "/images/smallLoader.gif" : "/images/icons/Icon-metro-attachment.svg"}
                                    />
                                </label>
                                <input
                                    accept=".png,.jpg,.jpeg,.xlx,.xlsx,.pdf,.mp4,.docx,.PNG,.JPG,.JPEG"
                                    onChange={(e) => {
                                        const fileName = e.target.files[0]?.name
                                        const ext = fileName.split(".")[fileName.split(".").length - 1];
                                        // console.log(ext !== "pdf")
                                        // console.log(ext !== "png" || ext !== "jpg" || ext !== "jpeg" || ext !== "xlx" || ext !== "xlsx" || ext !== "pdf" || ext !== "mp4" || ext !== "docx" || ext !== "doc")
                                        if (ext !== "png" && ext !== "jpg" && ext !== "jpeg" && ext !== "xlx" && ext !== "xlsx" && ext !== "pdf" && ext !== "mp4" && ext !== "docx" && ext !== "doc" && ext !== "PNG" && ext !== "JPG" && ext !== "JPEG") {
                                            Swal.fire("Error", "This file is not supported, we only support images, PDFs and mp4 files!", "error")
                                            return
                                        }
                                        if (!e.target.files[0]) return
                                        setLoading(true)
                                        dispatch(Actions.uploadFileToS3(e.target.files[0])).then((res) => {
                                            if (res.status != 1) return
                                            setLoading(false)
                                            const Obj = {
                                                // name: "RB Chrome qweqwqwrqzsdadafraeswew",
                                                name: meetingSession.configuration.credentials.externalUserId.split("#")[1],
                                                Text: res.uploadedName,
                                                time: new Date().toISOString(),
                                                file: res.fileName
                                            }
                                            dispatch({
                                                type: "CHAT",
                                                payload: { ...Obj, me: true, }
                                            })
                                            meetingSession?.audioVideo.realtimeSendDataMessage(DATA_MESSAGE_TOPIC, JSON.stringify(Obj), 100000)
                                            document.getElementById("filesss").value = ""
                                        })
                                    }}
                                    id="filesss" type="file" style={{ display: "none" }} />
                                <div className="type3">
                                    <form style={{ position: "relative" }} onSubmit={(e) => {
                                        e.preventDefault()
                                        if (Message) {

                                            const Obj = {
                                                // name: "RB Chrome",

                                                name: meetingSession.configuration.credentials.externalUserId.split("#")[1],
                                                Text: Message,
                                                time: new Date().toISOString(),
                                            }
                                            dispatch({
                                                type: "CHAT",
                                                payload: { ...Obj, me: true, }
                                            })
                                            meetingSession?.audioVideo.realtimeSendDataMessage(DATA_MESSAGE_TOPIC, JSON.stringify(Obj), 100000)
                                            setMessage("")

                                            // setMessages([
                                            //     ...Messages,
                                            //     { ...Obj, me: true, }
                                            // ])


                                        }

                                    }}>
                                        <span
                                            style={{ "position": "absolute", "top": "bottom", "bottom": "1px", "left": "10px", "color": "grey", "fontSize": "13px" }}
                                        >
                                            {Message.length}/200
                                        </span>
                                        <input
                                            value={Message}
                                            onChange={(e) => {
                                                if (e.target.value.length < 200) {
                                                    setMessage(e.target.value)
                                                }
                                            }}
                                            className="Type3Input"
                                            placeholder="Write a message!"

                                        />
                                    </form>
                                </div>
                                <label style={{ cursor: "pointer" }} className="type4"
                                    onClick={(e) => {
                                        if (Message) {
                                            const Obj = {
                                                name: meetingSession.configuration.credentials.externalUserId.split("#")[1],
                                                Text: Message,
                                                time: new Date().toISOString(),
                                            }
                                            dispatch({
                                                type: "CHAT",
                                                payload: { ...Obj, me: true, }
                                            })
                                            meetingSession?.audioVideo.realtimeSendDataMessage(DATA_MESSAGE_TOPIC, JSON.stringify(Obj), 100000)
                                            setMessage("")
                                        }
                                    }
                                    }
                                >
                                    <img
                                        style={{ height: "23px" }}
                                        // src="/images/icons/attachbtn.png"
                                        src={"/images/icons/send1.svg"}
                                    />
                                </label>
                            </div>

                        </div>

                    </>
                )
            }

        </div>
    )
}

PeoplesAndChat.propTypes = {

}

export default PeoplesAndChat
